import { supabase } from '@/integrations/supabase/client';
import { buildSiteSignInUrl, readSiteSignInToken } from '@/lib/siteSignInUrl';

/**
 * Signing the owner in on their own site when they click "View Website" in the
 * admin. The site lives on a different address from the admin, and browsers
 * keep sign-ins per address, so the admin asks the site-sign-in function for a
 * one-time token for the owner's own account and opens the site with it in the
 * URL fragment (never sent to any server). The site swaps it for its own
 * session and removes it from the address bar straight away.
 */
/** On page load: if the address carries a sign-in token, use it once and remove it. */
export async function consumeSiteSignIn(): Promise<void> {
  const token = readSiteSignInToken(window.location.hash);
  if (!token) return;
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
  const { error } = await supabase.auth.verifyOtp({ token_hash: token, type: 'magiclink' });
  if (error) console.warn('Could not sign you in on your site', error.message);
}

/** Ask for a one-time token for the signed-in owner's own account. */
export async function requestSiteSignInUrl(siteUrl: string, organizationId: string): Promise<string> {
  const { data, error } = await supabase.functions.invoke('site-sign-in', { body: { organizationId } });
  const tokenHash = (data as { tokenHash?: string } | null)?.tokenHash;
  if (error || !tokenHash) return siteUrl;
  return buildSiteSignInUrl(siteUrl, tokenHash);
}
